/**
 * 短链重定向中间件（只在服务端执行）
 */
import { oneApi } from 'config/api'

export default async function ({ req, redirect, $axios }) {
  // 客户端环境不执行
  if (process.client) return;
  const { url } = req;
  try {
    if (url.includes('/link/l/')) {
      // 拆分路径和查询参数
      const [path, query = ''] = url.split('?');
      const match = path.match(/\/link\/l\/([^/?#]+)/);
      const shortCode = match ? match[1] : null;
      if (!shortCode) return;
      const res = await $axios.post(oneApi.getOrigin, { url: shortCode });
      if (res.data) {
        // 判断返回的是否已有查询参数
        const connector = res.data.includes('?') ? '&' : '?';
        const finalUrl = query ? `${res.data}${connector}${query}` : res.data;
        // eslint-disable-next-line consistent-return
        return redirect(301, finalUrl);
      }
    }
  } catch (err) {
    console.error('Shortlink redirect failed:', err);
  }
}
